import React from 'react';
import PropTypes from 'prop-types';

import { Container, LeftColumn, RightColumn } from './styles';

const Props = {
  left: PropTypes.node.isRequired,
  right: PropTypes.node.isRequired,
};

export default function Overview({ left, right }) {
  return (
    <Container>
      <LeftColumn>{left}</LeftColumn>
      <RightColumn>{right}</RightColumn>
    </Container>
  );
}

Overview.propTypes = Props;
